import { createRouter, createWebHistory } from 'vue-router';
// eslint-disable-next-line import/no-cycle
import isAuth from '@/app/router/middleware/isAuth';
import hasContract from '@/app/router/middleware/hasContract';
import middlewarePipeline from '@/app/router/middleware/middlewarePipeline';
import initUser from '@/processes/User/initUser';
import noContract from '@/app/router/middleware/noContract';
import InfoStatusPage from '@/pages/InfoStatusPage';
import isNotAuth from '@/app/router/middleware/isNotAuth';
import notLoanApp from '@/app/router/middleware/notLoanApp';
// import hasLoanApp from '@/app/router/middleware/hasLoanApp';
import PayoutStatusPage from '@/pages/PayoutStatusPage';
import hasLoanApp from '@/app/router/middleware/hasLoanApp';
import store from '../store';

const Home = () => import(/* webpackChunkName: "homePage" */'@/pages/Home');
const MainPage = () => import(/* webpackChunkName: "mainPage" */'@/pages/MainPage');
const QrCodePayment = () => import(/* webpackChunkName: "qrCodePayment" */'@/pages/QrCodePayment');
const PaymentHistory = () => import(/* webpackChunkName: "paymentHistory" */'@/pages/PaymentHistory');
const Archieve = () => import(/* webpackChunkName: "archieve" */'@/pages/Archieve');
const Login = () => import(/* webpackChunkName: "login" */'@/pages/Login');
const EsiaRedirect = () => import(/* webpackChunkName: "esia-redirect" */'@/pages/EsiaRedirect');
const LoanApplication = () => import(/* webpackChunkName: "loan-application" */'@/pages/LoanApplication');
const SendMoney = () => import(/* webpackChunkName: "loan-application-sendmoney" */'@/pages/SendMoney');
const ContractInfo = () => import(/* webpackChunkName: "contract-info" */'@/pages/ContractInfo');
const ContractDocs = () => import(/* webpackChunkName: "contract-docs" */'@/pages/ContractDocs');
const SuccessPay = () => import(/* webpackChunkName: "success-pay" */'@/pages/SuccessPayPage');
const CancelPay = () => import(/* webpackChunkName: "cancel-pay" */'@/pages/CancelPayPage');
const PendingPay = () => import(/* webpackChunkName: "pending-pay" */'@/pages/PendingPayPage');
const Payment = () => import(/* webpackChunkName: "payment" */'@/pages/Payment');
const Approved = () => import(/* webpackChunkName: "approved" */'@/pages/ApprovedPage');
const Sw = () => import(/* webpackChunkName: "sw" */'@/pages/Sw/Sw.vue');
const NotFound = () => import(/* webpackChunkName: "NotFound" */'@/pages/NotFound');

export const routes = [
	{
		path: '/',
		name: 'home',
		component: Home,
		meta: { middleware: [isAuth, notLoanApp, noContract] },
	},
	{
		path: '/login',
		name: 'login',
		component: Login,
		meta: { middleware: [isNotAuth] },
	},
	{
		path: '/login/esia',
		name: 'esia-redirect',
		component: EsiaRedirect,
		meta: { middleware: [isNotAuth] },
	},
	{
		path: '/loan-app',
		name: 'loan-app',
		component: LoanApplication,
		meta: { middleware: [isAuth, notLoanApp, noContract] },
	},
	{
		path: '/info-status',
		name: 'info-status',
		component: InfoStatusPage,
		meta: { middleware: [isAuth, hasLoanApp] },
	},
	{
		path: '/payout-status',
		name: 'payout-status',
		component: PayoutStatusPage,
		meta: { middleware: [isAuth] },
	},
	{
		path: '/approved',
		name: 'approved',
		component: Approved,
		meta: { middleware: [isAuth, hasLoanApp] },
	},
	{
		path: '/sendmoney',
		name: 'sendmoney',
		component: SendMoney,
		meta: { middleware: [isAuth] },
	},
	{
		path: '/contract-info',
		name: 'contract-info',
		component: ContractInfo,
		meta: { middleware: [isAuth, hasContract] },
	},
	{
		path: '/contract-docs',
		name: 'contract-docs',
		component: ContractDocs,
		meta: { middleware: [isAuth, hasContract] },
	},
	{
		path: '/payment',
		name: 'payment',
		component: Payment,
		meta: { middleware: [isAuth, hasContract] },
	},
	{
		path: '/main-page',
		name: 'main-page',
		component: MainPage,
		meta: { middleware: [isAuth, hasContract] },
	},

	/*
	* Оплата
	* */
	{
		path: '/successpay',
		name: 'success-pay',
		component: SuccessPay,
		meta: { middleware: [isAuth, hasContract] },
	},
	{
		path: '/cancelpay',
		name: 'cancel-pay',
		component: CancelPay,
		meta: { middleware: [isAuth, hasContract] },
	},
	{
		path: '/state-payment/callback',
		name: 'pending-pay',
		component: PendingPay,
		meta: { middleware: [isAuth, hasContract] },
	},
	{
		path: '/payment-history',
		name: 'payment-history',
		component: PaymentHistory,
		meta: { middleware: [isAuth, hasContract] },
	},
	{
		path: '/qr-code-payment',
		name: 'qr-code-payment',
		component: QrCodePayment,
		meta: { middleware: [isAuth] },
	},
	{
		path: '/archieve',
		name: 'archieve',
		component: Archieve,
		meta: { middleware: [isAuth] },
	},
	{
		path: '/sw',
		name: 'sw',
		component: Sw,
	},
	{
		path: '/:pathMatch(.*)*',
		name: 'page-not-found',
		component: NotFound,
	},
];

export const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes,
	linkActiveClass: 'active',
});
router.beforeEach(async (to, from, next) => {
	if (store.state.token && !store.state.user) {
		await initUser();
	}

	if (!to.meta.middleware) {
		return next();
	}
	const { middleware } = to.meta;
	const context = {
		to,
		from,
		next,
		store,
		router,
	};

	return middleware[0]({
		...context,
		next: middlewarePipeline(context, middleware, 1),
	});
});
